/*
 * Copyright © 2025 AionTrack. All rights reserved.
 */

import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a duration in frames to timecode format (HH:MM:SS:FF)
 * @param frames - The duration in frames
 * @param fps - The frame rate (frames per second)
 * @returns Formatted timecode string or '-' if invalid input
 */
export function formatDuration(frames?: number, fps?: number): string {
  if (!frames || !fps) return '-'
  const totalSeconds = frames / fps
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = Math.floor(totalSeconds % 60)
  const remainingFrames = Math.floor(frames % fps)
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${remainingFrames.toString().padStart(2, '0')}`
}
